import { render, staticRenderFns } from "./MarketsSummary.vue?vue&type=template&id=351460b8&scoped=true&"
import script from "./MarketsSummary.vue?vue&type=script&lang=js&"
export * from "./MarketsSummary.vue?vue&type=script&lang=js&"
import style0 from "./MarketsSummary.vue?vue&type=style&index=0&id=351460b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351460b8",
  null
  
)

export default component.exports